<template>
    <PopupRouterView :showLeftIcon="true" label="Work Order Process Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="workorderprocess"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="workOrderProcessInput">


        <b-card header="Work Order Process" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Work Order Process Number" :model="model.workOrderProcessNumber" />
						<app-input-datepicker  id="fieldset-production-date" label-cols-lg="12"  label="Production Date" size="sm" :model.sync="model.productionDate" :isRequired="true" :state="validateState('productionDate')" :errorMessage="getErrorMessage(errorMessage.productionDate, 'productionDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line Code" id="fieldset-line-code" size="sm" :model.sync="model.lineCodeId" :isRequired="true" :state="validateState('lineCodeId')" :errorMessage="getErrorMessage(errorMessage.lineCodeId, 'lineCodeId')"   :selected="model.lineCode != null ? model.lineCode.code : ''" @input="getLines" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedLineCode" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Process Type" id="fieldset-process-type" size="sm" :model.sync="model.processTypeId" :isRequired="true" :state="validateState('processTypeId')" :errorMessage="getErrorMessage(errorMessage.processTypeId, 'processTypeId')"   :selected="model.processType != null ? model.processType.code : ''" @input="getProcessTypes" @change="onProcessTypeChange"  />
						<app-label label-cols-lg="12" size="sm" label="Process Type" :model="(model.processType != null) ? model.processType.name : null"  />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Work Order Process Detail"
			:bordered="true" :items="workOrderProcessDetails" 
			:fields="fieldsWorkOrderProcessDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByWorkOrderProcessDetail" 
			:sort-desc.sync="sortDescWorkOrderProcessDetail" small responsive	
			@editButtonMethod="editRowDataWorkOrderProcessDetail"	
			@deleteButtonMethod="deleteRowDataWorkOrderProcessDetail"	
			@showPopupAddMethod="addDataWorkOrderProcessDetail()"	
			@showPopupUploadMethod="showPopupUploadWorkOrderProcessDetail()"
			@downloadMethod="downloadWorkOrderProcessDetail()"
			@addFromClipboardMethod="addFromClipboardWorkOrderProcessDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardWorkOrderProcessDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadWorkOrderProcessDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowWorkOrderProcessDetailFilter = !isShowWorkOrderProcessDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowWorkOrderProcessDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select id="input-work-order-process-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterWorkOrderProcessDetail.partId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Bill Of Process">
					<v-select id="input-work-order-process-detail-bill-of-process-table" append-to-body label="partNumber" :options="billOfProcesss" :value="filterWorkOrderProcessDetail.billOfProcessId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.billOfProcessId" @search="getBillOfProcesss" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Line Machine">
					<v-select id="input-work-order-process-detail-machine-table" append-to-body label="code" :options="machines" :value="filterWorkOrderProcessDetail.machineId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.machineId" @search="getMachines" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty (Plan)">
					<b-form-input id="input-work-order-process-detail-qty-plan-table" v-model="filterWorkOrderProcessDetail.qtyPlan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Hour (Plan)">
					<b-form-input id="input-work-order-process-detail-hour-plan-table" v-model="filterWorkOrderProcessDetail.hourPlan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-work-order-process-detail-remark-table" v-model="filterWorkOrderProcessDetail.remark" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Document Status">
					<v-select id="input-work-order-process-detail-document-status-table" append-to-body label="name" :options="documentStatuss" :value="filterWorkOrderProcessDetail.documentStatusId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.documentStatusId" @search="getDocumentStatuss" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( workOrderProcessDetailPageSize * (currentWorkOrderProcessDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-process-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(partClassification)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(row.item.part != null) ? (row.item.part.partClassification != null) ? row.item.part.partClassification.code : null : null"  />
			</template>
			<template v-slot:cell(standarPackagingQty)="row">
						<app-label label-cols-lg="12" size="sm" label="Standard Packaging Qty" :model="(row.item.part != null) ? row.item.part.standarPackagingQty : null"  />
			</template>
			<template v-slot:cell(billOfProcess)="row">
				<app-input-combobox-autocomplete :options="billOfProcesss" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-process-detail-bill-of-process-' + row.index" label-cols-lg="12" label="Bill Of Process" size="sm" :model.sync="row.item.billOfProcessId"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.billOfProcess != null ? row.item.billOfProcess.partNumber : ''"  @input="getBillOfProcesss" :loading="isBillOfProcessComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(nextProcess)="row">
						<app-label label-cols-lg="12" size="sm" label="NextProcess" :model="(row.item.billOfProcess != null) ? (row.item.billOfProcess.nextProcess != null) ? row.item.billOfProcess.nextProcess.name : null : null"  />
			</template>
			<template v-slot:cell(machine)="row">
				<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" :id="'input-work-order-process-detail-machine-' + row.index" label-cols-lg="12" label="Line Machine" size="sm" :model.sync="row.item.machineId" :state="validateState('machineId')" :errorMessage="getErrorMessage(errorMessage.machineId, 'machineId')"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.machine != null ? row.item.machine.code : ''"  @input="getMachines" :loading="isMachineComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(sph)="row">
						<app-label label-cols-lg="12" size="sm" label="Stroke Per Hour" :model="(row.item.machine != null) ? row.item.machine.sph : null"  />
			</template>
			<template v-slot:cell(qtyPlan)="row">
				<app-input-textbox :id="'input-work-order-process-detail-qty-plan-' + row.index" label-cols-lg="12" label="Qty (Plan)" size="sm" :model.sync="row.item.qtyPlan" :state="validateState('qtyPlan')" :errorMessage="getErrorMessage(errorMessage.qtyPlan, 'qtyPlan')"   @change="saveInputWorkOrderProcessDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(hourPlan)="row">
				<app-input-textbox :id="'input-work-order-process-detail-hour-plan-' + row.index" label-cols-lg="12" label="Hour (Plan)" size="sm" :model.sync="row.item.hourPlan"   @change="saveInputWorkOrderProcessDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(customer)="row">
						<app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-work-order-process-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputWorkOrderProcessDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(documentStatus)="row">
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-work-order-process-detail-document-status-' + row.index" label-cols-lg="12" label="Document Status" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"    :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<WorkOrderProcessDetailInput 
					:model="modelWorkOrderProcessDetail"
					:openPopup="isShowPopupWorkOrderProcessDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataWorkOrderProcessDetail"/>
			</template>
			<template v-slot:upload-detail>
					<WorkOrderProcessDetailUpload
					:openPopup="isShowPopupUploadWorkOrderProcessDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataWorkOrderProcessDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentWorkOrderProcessDetailPage"
				:total-rows="totalWorkOrderProcessDetailRow"
				:per-page="workOrderProcessDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';

import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderProcessDetailInput from '@/views/WorkOrderProcess/WorkOrderProcessDetailInput';
import WorkOrderProcessDetailUpload from '@/views/WorkOrderProcess/WorkOrderProcessDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		WorkOrderProcessDetailInput,WorkOrderProcessDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			productionDate: {required},
			lineCodeId: {required},
			processTypeId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				productionDate: { required : "Production Date is Required."},
				lineCodeId: { required : "Line Code is Required."},
				processTypeId: { required : "Process Type is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsWorkOrderProcessDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part Number", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"partClassification": { "class" : "th-part-classification last-child", "label" : "Part Classification", key: 'partClassification', sortable: false}}, 
				{"standarPackagingQty": { "class" : "th-standar-packaging-qty d-stack-none", "label" : "Standard Packaging Qty", key: 'standarPackagingQty', sortable: false}}, 
				{"billOfProcess": { "class" : "th-bill-of-process d-stack-none", "label" : "Bill Of Process", key: 'billOfProcess', sortable: false}}, 
				{"nextProcess": { "class" : "th-next-process d-stack-none", "label" : "NextProcess", key: 'nextProcess', sortable: false}}, 
				{"machine": { "class" : "th-machine d-stack-none", "label" : "Line Machine", key: 'machine', sortable: false}}, 
				{"sph": { "class" : "th-sph d-stack-none", "label" : "Stroke Per Hour", key: 'sph', sortable: false}}, 
				{"qtyPlan": { "class" : "th-qty-plan d-stack-none", "label" : "Qty (Plan)", key: 'qtyPlan', sortable: false}}, 
				{"hourPlan": { "class" : "th-hour-plan d-stack-none", "label" : "Hour (Plan)", key: 'hourPlan', sortable: false}}, 
				{"customer": { "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelWorkOrderProcessDetail : {},
			isShowPopupWorkOrderProcessDetail : false,
			isShowPopupUploadWorkOrderProcessDetail : false,
			filterWorkOrderProcess : null,
			currentWorkOrderProcessPage : 1,
			workOrderProcessPageSize: 10,
			sortByWorkOrderProcess: '',
			sortDescWorkOrderProcess: '',
			filterWorkOrderProcessDetail : null,
			currentWorkOrderProcessDetailPage : 1,
			workOrderProcessDetailPageSize: 10,
			sortByWorkOrderProcessDetail: '',
			sortDescWorkOrderProcessDetail: '',
			sortingByWorkOrderProcessDetail: [],
			workOrderProcessDetails : [],
			workOrderProcessDetailId : '',
			totalWorkOrderProcessDetailRow : 0,
			isShowWorkOrderProcessDetailFilter: false,
			isDownloadWorkOrderProcessDetail: false,
			parts: [],
			billOfProcesss: [],
			machines: [],
			documentStatuss: [],
			lines: [],
			lineCodes: [],
			isLineCodeComboLoading: false,
			processTypes: [],
			processTypes: [],
			isProcessTypeComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isLineComboLoading: false,
			isProcessTypeComboLoading: false,
			isDocumentStatusComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isPartComboLoading: false,
			isBillOfProcessComboLoading: false,
			isMachineComboLoading: false,
		}
	},
	methods : {
		getWorkOrderProcess : async function(id) {
			this.isBusy = true;
			WorkOrderProcess.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.processTypeId != null) {
					promises.push(
						this.getProcessType(this.model.processTypeId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderProcess = true;
			this.filterWorkOrderProcess.id = this.modelId;
			WorkOrderProcess.downloadDataDetail(this, this.filterWorkOrderProcess).then(result => {
				this.isDownloadWorkOrderProcess = false;
			}).catch(error => { this.isDownloadWorkOrderProcess = false; })
		},
		getWorkOrderProcessDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderProcessDetail);
			if (this.modelId == null) return;
			filter.workOrderProcessId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByWorkOrderProcessDetail != null) {
				this.sortingByWorkOrderProcessDetail[this.sortByWorkOrderProcessDetail] = this.sortDescWorkOrderProcessDetail;
			}
			let currentPage = (this.currentWorkOrderProcessDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderProcessDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderProcessDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderProcessDetailPageSize = 0;
			// disable paging end
			WorkOrderProcessDetail.getList(this, filter, this.sortingByWorkOrderProcessDetail, currentPage , this.workOrderProcessDetailPageSize).then(result => {
				this.currentWorkOrderProcessDetailPage = currentPage + 1;
				this.workOrderProcessDetails = result.data;
				this.totalWorkOrderProcessDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.WorkOrderProcessNumber = input;
			}
			this.isWorkOrderProcessComboLoading = true;
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
				this.isWorkOrderProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			this.isWorkOrderProcessComboLoading = true;
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
				this.isWorkOrderProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfProcesss : async function(input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfProcessComboLoading = true;
			BillOfProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcesss = result.data
				}
				this.isBillOfProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLineCode(item) {
			if(item == undefined || item == null) {
				this.model.lineCodeId = null;
				this.model.lineCode = null;
			} else {
				this.model.lineCodeId = item.id;
				this.model.lineCode = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessType(item) {
			if(item == undefined || item == null) {
				this.model.processTypeId = null;
				this.model.processType = null;
			} else {
				this.model.processTypeId = item.id;
				this.model.processType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onProcessTypeChange : async function() {
			this.model.lineCodeId = null;
			this.model.lineCode = null;

			let item = this.model.processTypeId;
			let processTypeObj = this.processTypes.filter(function(processType){ return processType.id == item; });
			this.model.processType = processTypeObj.length > 0 ? processTypeObj[0] : null;
			this.getLineCodeByProcessType();
		},
		getLineCodeByProcessType : async function(input) {
			this.lineCodeState = false;
			this.$forceUpdate();

			let filter = new LineFilter();
			filter.processTypeId = this.model.processTypeId;
			if (input != undefined) {
				filter.code = input;
			}
			if (filter.processTypeId === undefined || filter.processTypeId === null || filter.processTypeId === '') {
				this.lineCodes = [];
			} else {
				Line.getList(this, filter, null, 0, 10)
					.then(result => {
						this.lineCodes = [];
						if (result != null) {
							this.lineCodes = result.data
						}
					})
					.catch(error => {
						this.lineCodes = [];
					});
			}

			this.lineCodeState = true;
			this.$forceUpdate();
		},

		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getProcessType : async function(id) {
			ProcessType.getData(this, id).then(result => {
				this.model.processType = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderProcessInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					WorkOrderProcess.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workorderprocessindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					WorkOrderProcess.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workorderprocessindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderProcess.updateData(this, model, id)
					.catch((error) => {
						this.getWorkOrderProcess(id);
					});
				}
			});
		},
		onHidden() {
			this.getWorkOrderProcesss();
		},
		addRowDataWorkOrderProcessDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				} else {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderProcessDetail(id) {
			this.workOrderProcessDetailId = id;
			this.isShowPopupWorkOrderProcessDetail = true; 
		},
		async deleteRowDataWorkOrderProcessDetail(id) {
			WorkOrderProcessDetail.deleteData(this, id).then(result => { this.getWorkOrderProcessDetails(); });
		},
		async resetDataWorkOrderProcessDetail() {
			this.workOrderProcessDetailId = "";
			this.isShowPopupWorkOrderProcessDetail = true;
		},
		async addDataWorkOrderProcessDetail() {
			WorkOrderProcessDetail.createData(this, { workOrderProcessId: this.modelId })
			.then(result => {
				this.getWorkOrderProcessDetails(true);
			})
		},
		async addFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.addFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});
		},
		async replaceFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.replaceFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});   
		},
		showPopupUploadWorkOrderProcessDetail() {
			if(this.workOrderProcessDetails != null && this.workOrderProcessDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap WorkOrderProcessDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadWorkOrderProcessDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadWorkOrderProcessDetail = true;
			}
		},
		uploadDataWorkOrderProcessDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
		},
		downloadWorkOrderProcessDetail(modalEvent) {
			this.isDownloadWorkOrderProcessDetail = true;
			this.filterWorkOrderProcessDetail.workOrderProcessId = this.modelId;
			WorkOrderProcessDetail.downloadDataDetail(this, this.filterWorkOrderProcessDetail).then(result => {
				this.isDownloadWorkOrderProcessDetail = false;
			}).catch(error => { this.isDownloadWorkOrderProcessDetail = false; })
		},
		saveInputWorkOrderProcessDetail(item) {
			if (this.workOrderProcesss != null && this.workOrderProcesss != undefined  && this.workOrderProcesss.length > 0) {
				item.workOrderProcess = this.workOrderProcesss.find(q => q.id == item.workOrderProcessId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.billOfProcesss != null && this.billOfProcesss != undefined  && this.billOfProcesss.length > 0) {
				item.billOfProcess = this.billOfProcesss.find(q => q.id == item.billOfProcessId);
			}
			if (this.machines != null && this.machines != undefined  && this.machines.length > 0) {
				item.machine = this.machines.find(q => q.id == item.machineId);
			}
			if (this.documentStatuss != null && this.documentStatuss != undefined  && this.documentStatuss.length > 0) {
				item.documentStatus = this.documentStatuss.find(q => q.id == item.documentStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderProcessDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
			this.isShowPopupWorkOrderProcessDetail = false; 
			if (modalType == 'WorkOrderProcessDetail') {
				this.getWorkOrderProcessDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowWorkOrderProcessDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterWorkOrderProcess = new WorkOrderProcessFilter();
		this.filterWorkOrderProcessDetail = new WorkOrderProcessDetailFilter();
		//this.getWorkOrderProcesss();
		//this.getParts();
		//this.getBillOfProcesss();
		//this.getMachines();
		//this.getDocumentStatuss();
		//this.getLines();
		//this.getProcessTypes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getWorkOrderProcess(id);
			} else {
				this.modelId = id;
				this.getWorkOrderProcess(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByWorkOrderProcessDetail : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		sortDescWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		currentWorkOrderProcessDetailPage: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		workOrderProcessDetailPageSize : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		filterWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			},
			deep: true,
		},
	},
}
</script>
